import { BE_FORM_DATE_FORMAT } from "@farzoom/common-ui-components";
import { Col } from "antd";
import moment, { Moment } from "moment";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect } from "react";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { FormInputDateTime } from "@app/common-ui-components/FormInputDateTime";

const validateStartDate = (current: Moment) => {
  const yesterday = moment().add(-1, "day");
  return current && current < yesterday;
};

const validateEndDate = (current: Moment, startDate: string | null) => {
  if (!startDate) return false;
  return current && current < moment(startDate, BE_FORM_DATE_FORMAT);
};

export const GuaranteeDuration = () => {
  const { control, setValue, setError, clearErrors } = useFormContext<BgFormInput>();
  const { formDisabled, prefix, isStartForm } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.guarantee` : "guarantee") as "guarantee";

  const [startDate, endDate] = useWatch({
    name: [`${currentPrefix}.startDate`, `${currentPrefix}.endDate`],
  });

  useEffect(() => {
    const start = moment(startDate, BE_FORM_DATE_FORMAT, true);
    const end = moment(endDate, BE_FORM_DATE_FORMAT, true);

    if (!start.isValid() || !end.isValid()) return;

    if (end.isBefore(start)) {
      setError(`${currentPrefix}.endDate`, {
        type: "custom",
        message: "Дата окончания не может быть раньше даты начала",
      });
      return;
    }

    clearErrors(`${currentPrefix}.endDate`);
  }, [startDate, endDate]);

  return (
    <>
      <Col span={isStartForm ? 12 : 6}>
        <FormInputDateTime
          name={`${currentPrefix}.startDate`}
          control={control}
          setValue={setValue}
          label="Дата начала гарантии"
          disabled={formDisabled}
          disabledDate={validateStartDate}
          required
        />
      </Col>
      <Col span={isStartForm ? 12 : 6}>
        <FormInputDateTime
          name={`${currentPrefix}.endDate`}
          control={control}
          setValue={setValue}
          label="Дата окончания"
          disabled={formDisabled}
          disabledDate={(current) => validateEndDate(current, startDate)}
          required
        />
      </Col>
    </>
  );
};
